/* eslint-disable prettier/prettier */
import STREAM_TYPE from './STREAM_TYPE';

const {
  COMPOSER,
  SLIDE,
  RTMP,
  HOST_MERGED,
  HOST_SUBSCRIBER,
  ISO_GUEST,
  ISO_MOBILE,
  ISO_SCREEN,
  ...publishers
} = STREAM_TYPE;

export default new Set(Object.values(publishers));
